import {
  GroupFilterBaseColumns,
  GroupFilterModel,
  useGroupListFilter,
  useSetGroupListFilter,
} from '@gripp/shared-logic';
import {
  ColumnsFilterScreen,
  ColumnsFilterScreenHandle,
  SlideAction,
  useSlideLayout,
} from '@gripp/shared-ui';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import { HeaderResetButton } from '../../shared/components/headerResetButton/headerResetButton';
import { GroupsBase } from './groups';

export const GroupsFilterPage = () => {
  const filterRef = useRef<ColumnsFilterScreenHandle>(null);
  const onBackButtonPressRef = useRef<(() => void) | undefined>(undefined);

  const { data: filter } = useGroupListFilter();
  const { mutateAsync: setFilter } = useSetGroupListFilter();
  const validateListOrder = async () => {};

  const rightColumn = {
    title: 'groups.menu.title',
    mainComponent: (
      <>
        <ColumnsFilterScreen
          ref={filterRef}
          mode="page"
          filter={filter}
          setFilter={setFilter}
          validateListOrder={validateListOrder}
          createDefaultFilter={() => new GroupFilterModel()}
          createFilter={(data) => new GroupFilterModel(data)}
          baseColumns={GroupFilterBaseColumns}
          i18nPrefix="groups.filter"
          viewResultsTranslationKey="common.apply"
          bottomBar={() => <></>}
        />
        <BackHandlerRegistrar onBackButtonPressRef={onBackButtonPressRef} />
      </>
    ),
    headerComponent: (
      <HeaderResetButton onReset={() => filterRef.current?.onReset()} />
    ),
    showBackButton: true,
    onBackButtonPress: () => onBackButtonPressRef.current?.(),
  };

  // GroupsBase uses PanelShell which auto-derives DUAL mode when rightColumn is provided.
  return <GroupsBase rightColumn={rightColumn} />;
};

const BackHandlerRegistrar = ({
  onBackButtonPressRef,
}: {
  onBackButtonPressRef: React.MutableRefObject<(() => void) | undefined>;
}) => {
  const navigate = useNavigate();
  const { onSlideChange } = useSlideLayout();

  onBackButtonPressRef.current = async () => {
    await onSlideChange(SlideAction.SINGLE);
    navigate('/groups');
  };

  return null;
};
